import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/DateUtils";
import { UserSubscription } from "../subscription/types";

interface Props {
    subscription: UserSubscription;
    timezone?: string;
}

function PaymentSubscriptionDetail({ subscription, timezone }: Props) {
    const { t } = useTranslation();
    return (
        <div className="subcription-detail-container">
            <div className="subscription-detail-row">
                <span className="subscription-detail-label">
                    {t("payment_modal.sub_status")}:
                </span>
                <span
                    className={`subscription-detail-value status-${subscription.status}`}
                >
                    {t(
                        subscription.status.replace(/^\w/, (c) =>
                            c.toUpperCase()
                        )
                    )}
                </span>
            </div>
            <div className="subscription-detail-row">
                <span className="subscription-detail-label">
                    {t("payment_modal.plan")}:
                </span>
                <span className="subscription-detail-value">
                    {t(subscription.payment_plan?.name)}
                </span>
            </div>
            {subscription.status === "active" && subscription.auto_renew && (
                <div className="subscription-detail-row">
                    <span className="subscription-detail-label">
                        {t("payment_modal.next_billing_date")}:
                    </span>
                    <span className="subscription-detail-value">
                        {formatDate(subscription.ends_at, "LL ", timezone)}
                    </span>
                </div>
            )}
            <div className="subscription-detail-row">
                <span className="subscription-detail-label">
                    {t("payment_modal.receipt")}:
                </span>
                <span className="subscription-detail-value">
                    {t("payment_modal.emailed")}
                </span>
            </div>
        </div>
    );
}

export default PaymentSubscriptionDetail;
